import {Component, inject} from "@angular/core";
import {Router} from "@angular/router";

@Component({
  templateUrl: './onboarding-wrapper.component.html',
  styleUrls: ['./onboarding-wrapper.component.scss']
})
export class OnboardingWrapperComponent {
  readonly #router = inject(Router);

  navigateToHome() {
    this.#router.navigate(['/app'])
  }
}
